import { render, staticRenderFns } from "./ShareFilePartner.vue?vue&type=template&id=9983eca6&scoped=true"
import script from "./ShareFilePartner.vue?vue&type=script&lang=js"
export * from "./ShareFilePartner.vue?vue&type=script&lang=js"
import style0 from "./ShareFilePartner.vue?vue&type=style&index=0&id=9983eca6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9983eca6",
  null
  
)

export default component.exports